import { httpClient } from "@coworker/http-client";

export async function postToTestbuyService<T = unknown>(
  path: string,
  bodyData: unknown,
  callback: (result: T) => void,
  responseType?: string
) {
  if (responseType === "blob") {
    const blob = await httpClient.testbuy.post<Blob>(`/${path}`, {
      body: bodyData,
      responseType: "blob",
    });
    callback(blob as T);
  } else {
    const result = await httpClient.testbuy.post<T>(`/${path}`, {
      body: bodyData,
    });
    if (result) callback(result);
  }
}

export async function fetchAPI(path: string, method: string, body?: unknown) {
  if (method === "GET") {
    return httpClient.testbuy.get(`/${path}`);
  }
  return httpClient.testbuy.post(`/${path}`, { body });
}
